module.exports = __webpack_public_path__ + "20ddb5848c96530f0332ff92e558e0ca.svg";